import { useEffect } from "react";
import { requestGetNameForResource } from "services/resources/library/aboutLibraryResources";

const useNameForCreatingResource = ({
    isCreate, form, 
    loadingRequest,
    doActionBeforeFillName
}) => {
    //#region Effects
    useEffect(() => {
        if (!form.value.resourceTypeId || !form.value.libraryId) return;
        doActionBeforeFillName && doActionBeforeFillName();
        fillNewNameForCreatingService();
    }, [form.value.resourceTypeId, form.value.libraryId]);
    //#endregion
    //#region Functions
    const fillNewNameForCreatingService = async () => {
        if (!isCreate) return;
        
        const params = {
            resourceTypeId: form.value.resourceTypeId,
            libraryId: form.value.libraryId
        };
        loadingRequest.show("Generando nombre...");
        // Obteniendo nombre nuevo del recurso
        const name = await requestGetNameForResource(params);
        form.set(prev => ({
            ...prev,
            name, 
            resourceTypeId: params.resourceTypeId,
            brandId: 0
        }));
        loadingRequest.hide();
    }
    //#endregion
}

export default useNameForCreatingResource;